import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { useAppDispatch, useAppSelector } from "store/hooks"
import { setInitialURL } from "store/tempDataSlise"

import { checkRoleType } from "utils/checkRoleType"
import { isRestrictedSubscriptionPlan } from "utils/isRestrictedSubscriptionPlan"

export const RedirectPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const initialURL = useAppSelector(state => state.tempData.initialURL)
  const userProfile = useAppSelector(state => state.user.userProfile)
  const userRole = checkRoleType(userProfile?.type)

  useEffect(() => {
    if (!userProfile) {
      navigate("/auth/sign-in")
    }

    if (initialURL) {
      navigate(initialURL)
      dispatch(setInitialURL(undefined))

      return
    }

    if (isRestrictedSubscriptionPlan(userProfile)) {
      navigate("/")
      return
    }

    if (["contractor-manager", "contractor-admin", "contractor-engineer"].includes(userRole || "")) {
      navigate("/dashboard")
    }

    if (userRole === "contractor-technician") {
      navigate("/customers")
    }

    if (userRole === "vendor-admin") {
      navigate("/contractors")
    }

    if (userRole === "warehouse-manager") {
      navigate("/wh-orders")
    }

    if (userRole === "sales-manager") {
      navigate("/contractors")
    }
  }, [])

  return null
}
